// JavaScript files are compiled and minified during the build process to the
// assets/built folder. See available scripts in the package.json file.

// Import CSS
import '../css/index.css';

// Import JS
import initColorScheme from './color-scheme';
import initContactForm from './contact-form';
import initHeaderNav from './header-nav';
import initMobileMenu from './mobile-menu';
import initStickyHeader from './sticky-header';
import lightense from './lightense';

// The bundle is deferred, so the document is parsed by the time this runs.
// Navigation first: it rebuilds the header list that the pre-hydration CSS
// guard is holding, and nothing below depends on it.
initHeaderNav();
initMobileMenu();
initStickyHeader();
if (document.documentElement.hasAttribute('data-color-scheme-toggle')) initColorScheme();
initContactForm();
lightense();
